/* eslint-disable import/prefer-default-export */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useInfiniteQuery, useMutation } from 'react-query';
import Highlighter from 'react-highlight-words';
import { Button, Col, Row, Dropdown, Spinner, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { StyledTh } from './styles';
import { ReactComponent as More } from '../../../../assets/images/icons/more.svg';
import { ReactComponent as List } from '../../../../assets/images/icons/list.svg';
import { ReactComponent as Eraser } from '../../../../assets/images/icons/eraser-solid.svg';
import { useCompanyHttpService } from '../../../../services/http/company-http';
import useIntersectionObserver from '../../../../hooks/useIntersectionObserver';
import { rowsPerPage } from '../../../../constants/pagination';
import { useCompany } from '../../../../contexts/companyContext';
import confirmDialog from '../../../../utils/dialog/confirmDialog';
import formatDateWithTime from '../../../../utils/localization/formatDateWithTime';
import isFriendlyHttpError from '../../../../utils/isFriendlyHttpError';

const IntegrationTable = (props: any) => {
    const {
        formData: filter,
        selectedCompany,
        reset,
        setSelectedIntegration,
        setShowIntegrationDetailModal,
    } = useCompany();

    const { indexIntegrations, removeIntegration } = useCompanyHttpService();

    const loadMoreRef = useRef();

    const mutationDelete = useMutation(
        async (id: number) => {
            await removeIntegration({
                integrationId: id,
            });
        },
        {
            onError: (error: any) => {
                if (isFriendlyHttpError(error)) {
                    toast.error(error.message);

                    return;
                }

                toast.error('Ocorreu um erro ao excluir o status.');
            },
            onSuccess: () => {
                toast.success('Status excluído com sucesso!');
            },
            onSettled: () => {
                refetch();
            },
        },
    );

    const loadCompanyIntegrations = async ({ pageParam = 0 }: any) => {
        const localStorageJson = JSON.parse(
            localStorage.getItem('branch') || '',
        );

        const params = {
            companyId: selectedCompany.id,
            skip: pageParam,
            take: rowsPerPage,
            erpTenantId:
                localStorageJson?.companyCode +
                ',' +
                localStorageJson.branchCode,
        };

        const response: any = await indexIntegrations(params);

        return {
            data: response.data.data,
            nextPage: pageParam,
        };
    };

    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, refetch } =
        useInfiniteQuery('companyIntegrations', loadCompanyIntegrations, {
            getNextPageParam: (lastPage) => lastPage.nextPage + 1,
        });

    useIntersectionObserver({
        target: loadMoreRef,
        onIntersect: fetchNextPage,
        enabled: hasNextPage,
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            refetch();
        }, 500);

        return () => clearTimeout(timer);
    }, [filter, refetch, reset]);

    return (
        <>
            <Row>
                <Col className="ml-2 mr-2">
                    <Table bordered hover size="sm" className="text-center">
                        <thead>
                            <tr>
                                <StyledTh>CHAVE</StyledTh>
                                <StyledTh>VALOR</StyledTh>
                                <StyledTh>FILIAL</StyledTh>
                                <StyledTh></StyledTh>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.pages &&
                                data?.pages.map((group: any) =>
                                    group?.data.map(
                                        (item: any, index2: any) => (
                                            <tr key={index2}>
                                                <td>
                                                    <Highlighter
                                                        autoEscape
                                                        highlightClassName="highlight-term"
                                                        searchWords={[
                                                            filter.term,
                                                        ]}
                                                        textToHighlight={item?.key.toString()}
                                                    />
                                                </td>
                                                <td>
                                                    <Highlighter
                                                        autoEscape
                                                        highlightClassName="highlight-term"
                                                        searchWords={[
                                                            filter.term,
                                                        ]}
                                                        textToHighlight={
                                                            item?.key ===
                                                            'TOKEN_EXPIRATION_DATE'
                                                                ? formatDateWithTime(
                                                                      item?.value.toString(),
                                                                  )
                                                                : item?.value.toString()
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <Highlighter
                                                        autoEscape
                                                        highlightClassName="highlight-term"
                                                        searchWords={[
                                                            filter.term,
                                                        ]}
                                                        textToHighlight={
                                                            item?.erpTenantId &&
                                                            item?.erpTenantId.toString()
                                                        }
                                                    />
                                                </td>
                                                <td className={'d-flex'}>
                                                    {}
                                                    <Dropdown key="left">
                                                        <Dropdown.Toggle
                                                            bsPrefix="nexen"
                                                            as={Button}
                                                            variant="text"
                                                        >
                                                            <More
                                                                width="10"
                                                                height="20"
                                                            />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setSelectedIntegration(
                                                                        item,
                                                                    );
                                                                    setShowIntegrationDetailModal(
                                                                        true,
                                                                    );
                                                                }}
                                                            >
                                                                <List
                                                                    width="18"
                                                                    height="18"
                                                                    className="ml-n3 mr-2"
                                                                />
                                                                Detalhes
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    const confirm: any =
                                                                        await confirmDialog(
                                                                            'Excluir chave de integração',
                                                                            'Deseja excluir a chave selecionada?',
                                                                            'info',
                                                                        );

                                                                    if (
                                                                        !confirm
                                                                    ) {
                                                                        return;
                                                                    }

                                                                    mutationDelete.mutateAsync(
                                                                        item?.id,
                                                                    );
                                                                }}
                                                            >
                                                                <Eraser
                                                                    width="18"
                                                                    height="18"
                                                                    className="ml-n3 mr-2"
                                                                />
                                                                Excluir
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ),
                                    ),
                                )}
                        </tbody>
                    </Table>
                </Col>

                <Col md={12} className="text-center">
                    {isFetchingNextPage ? (
                        <Col md={12} className="text-center">
                            <Spinner animation={'border'} />
                        </Col>
                    ) : (
                        <Col md={12} className="text-center">
                            <strong style={{ color: '#adadad' }}>
                                Sem itens para carregar
                            </strong>
                        </Col>
                    )}
                </Col>
            </Row>
        </>
    );
};

export { IntegrationTable };
